import menuAudiences from './menus/audiences.menu';
import menuAttributes from './menus/attributes.menu';
import menuCustomerInsights from './menus/customer_insights.menu';
import menuAnalticServices from './menus/analytic_services.menu';
import menuDataStrategy from './menus/data_strategy.menu';
import menuUseMetrics from './menus/use_metrics.menu';
import menuAssetGovernance from './menus/asset_governance.menu';
import menuPerformanceEvaluation from './menus/performance_evaluation.menu';
import { MENU_DICT, ROLES_LIST } from '@/js/constants';
import menuDataops from '@/configs/menus/dataops.menu';
import menuCh from '@/configs/menus/ch.menu';
export default {
  // main navigation - side menu
  menu: [{
    name: 'Home Page',
    key: 'menu.home_page',
    icon: 'icon-home_data_platform',
    color_icon: '#0D37E1',
    principal: 'HomePage',
    items: [],
    roles: [],
    sinRoles: true,
    pantallaInicial: false
  }, {
    name: 'Data Management',
    key: 'menu.data_platform',
    icon: 'icon-home_data_platform',
    color_icon: '#0D37E1',
    principal: 'MyTables',
    items: MENU_DICT,
    roles: [],
    sinRoles: true,
    pantallaInicial: true
  }, {
    name: 'Estrategia de Datos',
    key: 'menu.data_strategy',
    icon: 'icon-home_data_platform',
    color_icon: '#0D37E1',
    principal: 'AssessmentReport',
    items: menuDataStrategy,
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.ASSESSMENT_USER, ROLES_LIST.ASSESSMENT_ADMIN],
    sinRoles: false,
    pantallaInicial: false
  }, {
    name: 'Digital Audiences',
    key: 'menu.audience',
    icon: 'icon-home_audience',
    color_icon: '#00CFCF',
    principal: 'segments',
    items: menuAudiences,
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
    sinRoles: false,
    pantallaInicial: true
  }, {
    name: 'Attributes Marketplace',
    key: 'menu.attributes',
    icon: 'icon-home_attribute',
    color_icon: '#6200EA',
    principal: 'overview',
    items: menuAttributes,
    roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ORG_DATA_STEWARD],
    sinRoles: false,
    pantallaInicial: true
  }, {
    name: 'Customer Insights',
    icon: 'icon-home_insights',
    color_icon: '#48CBFF',
    principal: 'InsightsHome',
    key: 'menu.customer_insights',
    items: menuCustomerInsights,
    roles: [ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_SOMOS1_DATA_ENTRY_USER, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD],
    sinRoles: false,
    pantallaInicial: true
  }, {
    name: 'Analytics Services',
    key: 'menu.analytic_services',
    icon: 'mdi-laptop',
    color_icon: '#48CBFF',
    principal: 'MyResources',
    items: menuAnalticServices,
    roles: [ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ML_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    sinRoles: false,
    pantallaInicial: false,
    check_flag: 'analytic-services/has_mlops_active'
  }, {
    name: 'Chatbots',
    key: 'menu.chatbot_platform',
    icon: 'mdi mdi-robot-happy',
    color_icon: '#0D37E1',
    principal: 'ProjectManagement',
    items: menuCh,
    roles: [ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ML_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    sinRoles: true,
    pantallaInicial: true,
    check_flag: 'data-platform/has_hub_ia_active'
  }, {
    name: 'DataOps',
    key: 'menu.data_ops',
    icon: 'mdi-update',
    color_icon: '#48CBFF',
    principal: 'overviewdataops',
    items: menuDataops,
    roles: [ROLES_LIST.DATAOPS_USER, ROLES_LIST.ORG_DATA_STEWARD],
    sinRoles: false,
    pantallaInicial: true
  }, {
    name: 'Metricas INCA',
    key: 'menu.use_metrics',
    icon: 'mdi-chart',
    color_icon: 'green',
    principal: 'use_metrics',
    items: menuUseMetrics,
    roles: [],
    sinRoles: true,
    pantallaInicial: false
  }, {
    name: 'Gobierno de Activo',
    key: 'menu.asset_governance',
    icon: 'mdi-chart',
    color_icon: 'green',
    principal: 'asset_governance',
    items: menuAssetGovernance,
    roles: [ROLES_LIST.USER],
    sinRoles: false,
    pantallaInicial: false
  }, {
    name: 'Evaluacion de Desempeno',
    key: 'menu.performance_evaluation',
    icon: 'mdi-clipboard-check-outline',
    color_icon: '#6200EA',
    principal: 'performance_evaluation',
    items: menuPerformanceEvaluation,
    roles: [],
    sinRoles: true,
    pantallaInicial: false
  }

  /* {
    name: 'Configuration',
    key: 'menu.configuration',
    items: configMenu,
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN],
    sinRoles: false
  }*/],
  // footer links
  footer: [{
    text: 'Docs',
    key: 'menu.docs',
    href: 'https://vuetifyjs.com',
    target: '_blank'
  }]
};